import {List} from 'immutable';

// must be in order of size (scale)
// scale is in seconds (thus all damping on this page must conform)
export const throttleOptions = List([
  {label: 'Minute(s)', value: 'minute', scale: 60},
  {label: 'Hour(s)', value: 'hour', scale: 60 * 60},
  {label: 'Day(s)', value: 'day', scale: 60 * 60 * 24},
  {label: 'Week(s)', value: 'week', scale: 60 * 60 * 24 * 7},
  {label: 'Month(s)', value: 'month', scale: 60 * 60 * 24 * 30},
]);
